import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  Input,
} from "@material-ui/core";
import { useWeb3React } from "@web3-react/core";
import { Redirect } from "react-router-dom";

import TokenPool from "../components/SearchTokenPools/TokenPool";
import ManageFundsModal from "../components/Modals/ManageFundsModal";
import InputWithDropdown from "../components/Inputs/InputWithDropdown";
import InputWithLabel from "../components/Inputs/InputWithLabel";

import {
  depositTokenProject,
  withdrawRewardKol,
  withdrawFundsProject,
  getClaimablebyKolId,
  isUser,
} from "../redux/actions/web3Actions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    // textAlign: "center",
    display: "flex",
    justifyContent: "center",
    // border: "1px solid",
  },

  tabBox: {
    marginTop: "6rem",
    backgroundColor: "white",
    borderRadius: "7px",
    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",

    padding: "1rem",
    width: "fit-Content",
  },
  activeTab: {
    borderRadius: "6px",
    backgroundColor: "#f63089",
    padding: "1rem",
    color: "white",
    fontWeight: "600",
    fontSize: "1.2rem",
  },
  inActiveTab: {
    backgroundColor: "transparent",
    padding: "1rem",
    color: "#f63089",
    fontWeight: "600",
    fontSize: "1.2rem",
  },
  insideBox: {
    display: "flex",
    // border: "1px solid  #f63089",
    borderRadius: "7px",
    cursor: "pointer",
    fontWeight: "600",
  },
  contentBox: {
    padding: "2rem 4rem",
    backgroundColor: "white",
    width: "50rem",
    // border: "1px solid",
    marginTop: "4rem",
    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",
  },
  button: {
    padding: "0.7rem 3.3rem",
    fontWeight: "600",
    width: "14rem",
  },
  heading: {
    marginBottom: "0.9rem",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
  },
  input: {
    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",
  },
  text: {
    marginBottom: "3rem",
    fontSize: "1.4rem",
    opacity: "0.5",
  },
  poolLabelValue: {
    fontWeight: "600",
    fontSize: "1.2rem",
  },
}));

const SearchTokenPools = () => {
  const classes = useStyles();
  const isUser = useSelector((state) => state.ui.isUser);
  const [singleId, setSingleId] = useState([]);
  const [activeTab, setActiveTab] = useState(2);
  const [camid, setCamId] = useState();
  const [options, setOptions] = useState([]);
  const [claimId, setClaimId] = useState([]);

  const [depositValue, setDepositValue] = useState();
  const [withdrawValue, setWithdrawValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const web3Context = useWeb3React();
  // const investmentData = useSelector((state) => state.ui.investmentData);
  // console.log("investmentData ========", investmentData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isUser?.project?.campaigns) {
      setOptions(
        isUser.project.campaigns.map((d) => {
          return { name: d.campaignName, id: d._id };
        })
      );
    }
    if (isUser?.kol) {
      setOptions(
        isUser.kol.campaignsId.map((d) => {
          return { name: d.campaignName, id: d._id };
        })
      );
    }

    if (singleId[0]) {
      setWithdrawValue(singleId[0].invested);
    }
    // if (!isUser.project && !isUser.kol) {
    //   console.log("hjedwjedhjhedwkjhefedjhfekjfekjhf");
    //   return <Redirect to="/" />;
    // }
  }, [isUser, singleId]);
  const callbackFunction = () => {
    setShowModal(true);

    // console.log("HASAN CHALA");
  };
  const onDeposit = () => {
    console.log("ON DEPOIST CHAL GAYA");
    dispatch(
      depositTokenProject(
        web3Context.account,
        isUser.project._id,
        "0x5186a9ed44b1011be7e1aaef9c1bc9eaf327cd5b",
        depositValue,
        callbackFunction
      )
    );
    // setShowModal(true);
  };

  const onWithdrawTokens = () => {
    console.log("onWithdrawTokens CHAL GAYA");

    dispatch(
      withdrawRewardKol(
        web3Context?.account,
        camid,
        withdrawValue,
        callbackFunction
      )
    );
    // setShowModal(true);
  };

  const onWithdrdawFunds = () => {
    console.log("onWithdrdawFunds CHAL GAYA");

    dispatch(
      withdrawFundsProject(
        web3Context?.account,
        camid,
        withdrawValue,
        callbackFunction
      )
    );
    // setShowModal(true);
  };

  const handleChange = (event) => {
    console.log("opt", event);
    setCamId(event);

    if (isUser.kol) {
      const singleId2 = claimId.filter((cid) => cid.campaignId._id == event);
      setSingleId(singleId2);
      console.log({ singleId, singleId2, claimId });

      setWithdrawValue(singleId2[0]?.invested);
    }
  };

  useEffect(() => {
    if (isUser?.kol?._id) {
      const func = async () => {
        const claimDataByKol = await getClaimablebyKolId(isUser?.kol?._id);
        setClaimId(claimDataByKol);
        console.log({ claimDataByKol });
      };
      func();
    }
  }, [isUser]);

  // console.log({ activeTab });
  return (
    <Box>
      <Box className={classes.container}>
        <Box className={classes.tabBox}>
          <Box className={classes.insideBox}>
            {!isUser.kol && isUser.project && (
              <Box
                className={
                  activeTab == 1 ? classes.activeTab : classes.inActiveTab
                }
                onClick={() => {
                  setActiveTab(1);
                }}
              >
                {isUser?.project ? "Deposit Token" : null}
              </Box>
            )}
            <Box
              className={
                activeTab == 2 ? classes.activeTab : classes.inActiveTab
              }
              onClick={() => {
                setActiveTab(2);
              }}
            >
              {isUser?.kol ? "Withdraw Tokens" : " Withdraw Funds"}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.contentBox}>
          <h1 className={classes.heading}>
            {activeTab == 1 && isUser?.kol
              ? "Deposit Funds"
              : activeTab == 1 && isUser?.project
              ? " Deposit Token"
              : activeTab == 2 && isUser?.kol
              ? "Withdraw Tokens"
              : activeTab == 2 && isUser?.project
              ? "Withdraw Funds"
              : null}
          </h1>

          <p className={classes.text}>
            {activeTab == 1
              ? "Deposit Project Tokens for your Compaign"
              : "Withdraw USDT from Pool"}
          </p>
          {activeTab == 1 ? (
            <InputWithLabel
              value={depositValue}
              setValue={setDepositValue}
              placeholder={activeTab == 1 ? "Enter Tokens" : "Enter Funds"}
              className={classes.inputs}
            />
          ) : (
            <InputWithDropdown
              options={options}
              handleChange={handleChange}
              value={withdrawValue}
              setValue={setWithdrawValue}
              placeholder={"Enter Funds"}
              className={classes.inputs}
            />
          )}
          <Button
            className={classes.button}
            onClick={() => {
              activeTab == 1 && isUser.project
                ? onDeposit()
                : activeTab == 2 && isUser.project
                ? onWithdrdawFunds()
                : onWithdrawTokens();
            }}
          >
            <Typography className={classes.poolLabelValue}>
              {activeTab == 1 ? "Deposit" : "Withdraw"}
            </Typography>
          </Button>
        </Box>
      </Box>
      <ManageFundsModal
        showModal={showModal}
        setShowModal={setShowModal}
        text={
          activeTab == 1 ? "Succesfully Deposited" : "Succesfully Withdrawn"
        }
      />
    </Box>
  );
};

export default SearchTokenPools;
